import { render, staticRenderFns } from "./BatchUpload.vue?vue&type=template&id=48faa842&scoped=true"
import script from "./BatchUpload.vue?vue&type=script&lang=js"
export * from "./BatchUpload.vue?vue&type=script&lang=js"
import style0 from "./BatchUpload.vue?vue&type=style&index=0&id=48faa842&prod&lang=less&scoped=true"
import style1 from "./BatchUpload.vue?vue&type=style&index=1&id=48faa842&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48faa842",
  null
  
)

export default component.exports